
        <a [routerLink]="linkUrl" routerLinkActive="router-link-active" [ngClass]="{collapsed: sideBar?.isCollapsed, admin: adminOnly}"><svg-icon name="{{icon}}"></svg-icon><span class="menuText">{{itemTitle|trans}}</span></a>
    